import { render } from "./Train.vue?vue&type=template&id=14bb5be4"
import script from "./Train.vue?vue&type=script&lang=ts"
export * from "./Train.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QInput,QIcon,QSeparator,QScrollArea});
